import { RootState, useAppDispatch } from "@redux/store";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { setFavoritedRowIds } from "@redux/slices/model-screener";
import { useModelScreener } from "@hooks/useModelScreener";
import { MSTableFavouritedButton } from "@pages/managed-accounts/model-screener/components/model-screener-table/checkboxes/favorited-select/favourited-button";

type MSTableFavoritedSelectProps = {
  rowId: string;
};

export const MSTableFavoritedSelect = ({
  rowId,
}: MSTableFavoritedSelectProps) => {
  const dispatch = useAppDispatch();
  const { putModelScreenerFavoriteModels } = useModelScreener();

  const favoritedRowIds = useSelector(
    (state: RootState) => state.modelScreener.favouritedRowIds,
  );
  const isPatchingFavoritedModels = useSelector(
    (state: RootState) => state.modelScreener.ui.isPatchingFavoritedModels,
  );

  const handleOnFavoritedClicked = async (): Promise<boolean> => {
    const shouldAddToFavorites = !isFavorited;

    const originalFavoritedRowIds = Object.keys(favoritedRowIds);
    const newFavoritedRowIds = shouldAddToFavorites
      ? [...originalFavoritedRowIds, rowId]
      : originalFavoritedRowIds.filter((id) => id !== rowId);

    const response = await putModelScreenerFavoriteModels(newFavoritedRowIds);

    if (!response) {
      return false;
    }

    dispatch(setFavoritedRowIds(newFavoritedRowIds));
    return true;
  };

  const isFavorited = useMemo(
    () => !!favoritedRowIds[rowId],
    [rowId, favoritedRowIds],
  );

  return (
    <MSTableFavouritedButton
      onHandleFavoriteStatus={handleOnFavoritedClicked}
      isFavourite={isFavorited}
      isDisabled={isPatchingFavoritedModels}
      showDisabledStyles={false}
    />
  );
};
